"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertLineToArc = convertLineToArc;
var _vector = require("./vector");
/**
 * Compute the arc that terminates at the given points with the specified bulge.
 * @param {Point} P The first point
 * @param {Point} Q The second point
 * @param {Number} b The bulge factor
 * @returns {Arc} An ARC entity
 */
function convertLineToArc(P, Q, b) {
  if (b === 0) throw new Error('Cannot convert to arc: bulge factor is 0');
  const neg = Math.sign(b);
  b = Math.abs(b);
  const PQ = (0, _vector.sub)(Q, P);
  const d = (0, _vector.norm)(PQ);
  if (d < 1e-15) {
    throw new Error('Cannot convert to arc: line segment is zero length');
  }
  const bd = b * d / 2;
  const r = bd / 2 + d * d / (8 * bd);
  const l = r - bd;
  const M = (0, _vector.mul)((0, _vector.add)(P, Q), 0.5);
  const MC = {
    x: -PQ.y,
    y: PQ.x
  };
  const C = (0, _vector.add)(M, (0, _vector.mul)(MC, neg * l / d));
  const CP = (0, _vector.sub)(P, C);
  const CQ = (0, _vector.sub)(Q, C);
  let startAngle = Math.atan2(CP.y, CP.x);
  let endAngle = Math.atan2(CQ.y, CQ.x);
  let reversed = false;
  if (neg < 0) {
    const temp = startAngle;
    startAngle = endAngle;
    endAngle = temp;
    reversed = true;
  }

  // Correct the angles
  while (startAngle < 0) startAngle += Math.PI * 2;
  while (startAngle >= Math.PI * 2) startAngle -= Math.PI * 2;
  while (endAngle < startAngle) endAngle += Math.PI * 2;
  return {
    type: 'ARC',
    x: C.x,
    y: C.y,
    r,
    startAngle,
    endAngle,
    reversed
  };
}